/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
  color?: string;
};

const SvgComponent: FC<IProps> = ({ width = 20, height = 20 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="stethoscope">
      <path
        id="Vector"
        d="M4.2398 3.38266C4.82313 3.19126 5.13563 2.57261 4.94119 1.99839C4.74674 1.42417 4.11827 1.11655 3.53841 1.30454L2.63216 1.6019C1.72244 1.90268 1.11133 2.73667 1.11133 3.68003V7.81235C1.11133 10.8338 3.59744 13.2811 6.66688 13.2811C9.73633 13.2811 12.2224 10.8338 12.2224 7.81235V3.68003C12.2224 2.74009 11.6113 1.90268 10.7016 1.60532L9.79536 1.30454C9.21202 1.11313 8.58355 1.42417 8.38911 1.99497C8.19466 2.56577 8.51063 3.18784 9.09049 3.37925L10.0002 3.68003V7.81235C10.0002 9.62388 8.50716 11.0936 6.66688 11.0936C4.82661 11.0936 3.33355 9.62388 3.33355 7.81235V3.68003L4.2398 3.38266ZM17.778 7.81235C17.778 8.10243 17.6609 8.38063 17.4526 8.58575C17.2442 8.79087 16.9616 8.9061 16.6669 8.9061C16.3722 8.9061 16.0896 8.79087 15.8812 8.58575C15.6728 8.38063 15.5558 8.10243 15.5558 7.81235C15.5558 7.52227 15.6728 7.24407 15.8812 7.03895C16.0896 6.83384 16.3722 6.7186 16.6669 6.7186C16.9616 6.7186 17.2442 6.83384 17.4526 7.03895C17.6609 7.24407 17.778 7.52227 17.778 7.81235ZM16.6669 5.07798C15.9302 5.07798 15.2236 5.36606 14.7027 5.87886C14.1818 6.39165 13.8891 7.08715 13.8891 7.81235C13.8891 8.53755 14.1818 9.23305 14.7027 9.74585C15.2236 10.2586 15.9302 10.5467 16.6669 10.5467C17.4036 10.5467 18.1101 10.2586 18.6311 9.74585C19.152 9.23305 19.4447 8.53755 19.4447 7.81235C19.4447 7.08715 19.152 6.39165 18.6311 5.87886C18.1101 5.36606 17.4036 5.07798 16.6669 5.07798Z"
        fill="#D6C7BA"
      />
      <path
        id="Vector_2"
        opacity="0.6"
        d="M15.5569 10.3184V12.7349C15.5569 14.8506 13.8173 16.563 11.668 16.563C9.66797 16.563 8.02214 15.0796 7.80339 13.1689C7.43533 13.2441 7.05686 13.2817 6.66797 13.2817C6.29297 13.2817 5.92839 13.2441 5.57422 13.1758C5.80339 16.293 8.44227 18.7505 11.668 18.7505C15.043 18.7505 17.7791 16.0571 17.7791 12.7349V10.3184C17.4388 10.4653 17.0638 10.5474 16.668 10.5474C16.2721 10.5474 15.8971 10.4653 15.5569 10.3184Z"
        fill="#D6C7BA"
      />
    </g>
  </svg>
);

export default SvgComponent;
